export default __webpack_public_path__ + "51e5113e9d85fe685744224ce30b539e.svg";